import { createApiClient } from './softgarden/api.js';
import { initSoftgardenFlow } from './softgarden/flow.js';

const readMessages = (root) => ({
	loadError: root.dataset.msgLoadError || 'Formular konnte nicht geladen werden. Bitte Seite neu laden oder später erneut versuchen.',
	submitError: root.dataset.msgSubmitError || 'Bewerbung konnte nicht gesendet werden. Bitte Angaben prüfen und erneut versuchen.',
	loginError: root.dataset.msgLoginError || 'Anmeldung fehlgeschlagen. Bitte E-Mail und Passwort prüfen.',
	loginSuccess: root.dataset.msgLoginSuccess || 'Angemeldet. Bitte Bewerbung absenden.',
	passwordResetSent: root.dataset.msgPasswordReset || 'Link zum Zurücksetzen wurde versendet.',
	passwordResetExternal: root.dataset.msgPasswordResetExternal || 'Passwort-Reset öffnet sich in Softgarden. Danach hier mit dem neuen Passwort anmelden.',
	passwordResetInvalidUrl: root.dataset.msgPasswordResetInvalidUrl || 'Softgarden akzeptiert die Reset-URL nicht. Bitte Softgarden-Support kontaktieren (Return-URL freischalten).',
	passwordResetError: root.dataset.msgPasswordResetError || 'Passwort-Reset fehlgeschlagen.',
	emailRequired: root.dataset.msgEmailRequired || 'Bitte E-Mail angeben.',
	cvRequired: root.dataset.msgCvRequired || 'Bitte Lebenslauf hochladen.',
	fileTooLarge: root.dataset.msgFileTooLarge || 'Datei ist zu groß. Maximal 10 MB pro Datei.',
	uploadError: root.dataset.msgUploadError || 'Die Datei konnte nicht hochgeladen werden. Bitte PDF oder DOCX verwenden und erneut versuchen.',
	uploadServerLimit: root.dataset.msgUploadServerLimit || 'Die Datei konnte nicht hochgeladen werden (Server-Upload-Limit). Bitte eine kleinere Datei wählen oder später erneut versuchen.',
	resetSuccess: root.dataset.msgResetSuccess || 'Passwort wurde aktualisiert. Bitte melde dich an, um fortzufahren.',
	resetMismatch: root.dataset.msgResetMismatch || 'Die Passwörter stimmen nicht überein.',
	resetInvalid: root.dataset.msgResetInvalid || 'Das Passwort erfüllt nicht die Anforderungen.',
	resetTokenMissing: root.dataset.msgResetTokenMissing || 'Der Link zum Zurücksetzen ist ungültig oder abgelaufen.',
	authRequired: root.dataset.msgAuthRequired || 'Deine Sitzung ist abgelaufen. Bitte melde dich erneut an oder bewirb dich noch einmal.',
	alreadyApplied: root.dataset.msgAlreadyApplied || 'Du hast dich für diese Stelle bereits beworben. Eine erneute Bewerbung ist nicht möglich.',
	genericError: root.dataset.msgGenericError || 'Es ist ein Fehler aufgetreten. Bitte versuche es erneut oder bewirb dich über XING / LinkedIn.',
	loadingDefault: root.dataset.msgLoadingDefault || 'Formular wird vorbereitet …',
	loadingSubmit: root.dataset.msgLoadingSubmit || 'Bewerbung wird übermittelt …',
	loadingUpload: root.dataset.msgLoadingUpload || 'Dateien werden hochgeladen … Das kann einen Moment dauern.',
});

export const softgardenApply = () => {
	const roots = document.querySelectorAll('#softgarden-apply');

	if (!roots.length) return;

	roots.forEach((root) => {
		const api = createApiClient(root);
		initSoftgardenFlow(root, api, readMessages(root));
	});
};
